import { format, formatDistanceToNow, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

import type { Post } from "../types";

export function formatPostDate(iso: string) {
	return format(parseISO(iso), "dd 'de' MMM 'de' yyyy", { locale: ptBR });
}

export function formatPostTime(iso: string) {
	return format(parseISO(iso), "HH:mm");
}

export function formatRelativeTime(iso: string) {
	return formatDistanceToNow(parseISO(iso), { addSuffix: true, locale: ptBR });
}

export function groupPostsByDate(posts: Post[]): [string, Post[]][] {
	const groups = new Map<string, Post[]>();

	for (const post of posts) {
		const day = post.date.slice(0, 10);
		const bucket = groups.get(day);
		if (bucket) {
			bucket.push(post);
		} else {
			groups.set(day, [post]);
		}
	}

	return [...groups.entries()].sort((a, b) => b[0].localeCompare(a[0]));
}
